/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import React from 'react';

const getHeatColor = (value) => {

  if (value >= 25) {
    return 'bg-green-700 text-white';
  }

  if (value >= 15) {
    return 'bg-green-500 text-white';
  }

  if (value >= 8) {
    return 'bg-green-100 text-green-800';
  }

  if (value >= 0) {
    return 'bg-yellow-100 text-yellow-800';
  }

  return 'bg-red-200 text-red-800';
};


const CategoryHeatmap = ({ data }) => {

  return (

    <div className="bg-white rounded-3xl p-8 shadow-sm border">

      {/* HEADER */}
      <div className="mb-8">

        <h2 className="text-3xl font-bold text-gray-900 mb-2">
          Category Performance Heatmap
        </h2>

        <p className="text-gray-500">
          Compare category-wise performance trends across different time horizons.
        </p>

      </div>


      {/* TABLE */}
      <div className="overflow-x-auto">

        <table className="w-full border-separate border-spacing-y-3">

          {/* TABLE HEADER */}
          <thead>

            <tr>

              <th className="text-left text-sm text-gray-500 font-semibold pb-3">
                CATEGORY
              </th>

              <th className="text-center text-sm text-gray-500 font-semibold pb-3">
                1M
              </th>

              <th className="text-center text-sm text-gray-500 font-semibold pb-3">
                3M
              </th>

              <th className="text-center text-sm text-gray-500 font-semibold pb-3">
                1Y
              </th>

            </tr>

          </thead>


          {/* BODY */}
          <tbody>

            {data.map((row, index) => (

              <tr
                key={index}
                className="bg-gray-50 rounded-2xl"
              >

                {/* CATEGORY */}
                <td className="py-5 px-5 rounded-l-2xl">

                  <div className="font-semibold text-gray-900">
                    {row.sub_category}
                  </div>

                </td>


                {/* 1M */}
                <td className="text-center">

                  <div
                    className={`
                      inline-block
                      px-5
                      py-3
                      rounded-xl
                      font-bold
                      min-w-[90px]
                      ${getHeatColor(Number(row.r1m))}
                    `}
                  >
                    {/*{row.r1m?.toFixed(1)}%    */}
                    {Number(row.r1m).toFixed(2)}%
                  </div>

                </td>


                {/* 3M */}
                <td className="text-center">

                  <div
                    className={`
                      inline-block
                      px-5
                      py-3
                      rounded-xl
                      font-bold
                      min-w-[90px]
                      ${getHeatColor(Number(row.r3m))}
                    `}
                  >
                    {/*{row.r3m?.toFixed(1)}%*/}
                    {Number(row.r3m).toFixed(2)}%

                  </div>

                </td>


                {/* 1Y */}
                <td className="text-center rounded-r-2xl">

                  <div
                    className={`
                      inline-block
                      px-5
                      py-3
                      rounded-xl
                      font-bold
                      min-w-[90px]
                      ${getHeatColor(Number(row.r1y))}
                    `}
                  >
                    {/*{row.r1y?.toFixed(1)}%*/}
                    {Number(row.r1y).toFixed(2)}%
                  </div>

                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>


      {/* LEGEND */}
      <div className="flex flex-wrap gap-4 mt-8">

        <div className="flex items-center gap-2">
          <div className="w-5 h-5 rounded bg-green-700"></div>
          <span className="text-sm text-gray-600">
            Very Strong
          </span>
        </div>

        <div className="flex items-center gap-2">
          <div className="w-5 h-5 rounded bg-green-500"></div>
          <span className="text-sm text-gray-600">
            Strong
          </span>
        </div>

        <div className="flex items-center gap-2">
          <div className="w-5 h-5 rounded bg-green-100"></div>
          <span className="text-sm text-gray-600">
            Moderate
          </span>
        </div>

        <div className="flex items-center gap-2">
          <div className="w-5 h-5 rounded bg-yellow-100"></div>
          <span className="text-sm text-gray-600">
            Neutral
          </span>
        </div>

        <div className="flex items-center gap-2">
          <div className="w-5 h-5 rounded bg-red-200"></div>
          <span className="text-sm text-gray-600">
            Weak
          </span>
        </div>

      </div>

    </div>
  );
};

export default CategoryHeatmap;